import type { Device } from '@packages/shared/src/utils/types';

export const getChannelFromDevice = (device: Device) => {
  if (device === 'mobile') return 'mob';
  if (device === 'tablet') return 'tab';

  return 'web';
};
